// extracted by mini-css-extract-plugin
export var dividerLine = "_63-3";
export var itemImage = "_63-9";
export var lightDivider = "_63-4";
export var modalContent = "_63-5";
export var modalContentCompact = "_63-6";
export var productCard = "_63-a";
export var productImage = "_63-b";
export var productImageCompact = "_63-7";
export var productImagePlaceholder = "_63-c";
export var productImagePlaceholderCompact = "_63-8";
export var progressBarBackground = "_63-1";
export var progressBarContainer = "_63-0";
export var progressBarFill = "_63-2";